<template>

    <div class="row row-cols-lg-auto gx-3 align-items-center">

        <div class="mb-3">
            <label class="form-label">{{ __('Search') }}</label>
            <input class="form-control" 
                   autocomplete="off" 
                   type="search" 
                   name="search" 
                   :placeholder="__('Search')" 
                   :value="value"
                   @input="$emit('input', $event.target.value)" />
        </div>

        <slot />

        <div class="pt-3">
            <button class="btn btn-link" 
                    type="button" 
                    @click="$emit('reset')">
                <i class="bi bi-x-lg"></i>
                {{ __('Reset') }}
            </button>
        </div>

    </div>

</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';

    export default {
        props: {
            value: String,
        },
        components: {
            TextInput,
        },
    }
</script>